"use strict";

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APIClient = void 0;

var node_1 = require("./node");

var account_1 = require("./account");

var block_1 = require("./block");

var transaction_1 = require("./transaction");

var APIClient = /*#__PURE__*/function () {
  function APIClient(channel) {
    _classCallCheck(this, APIClient);

    this._channel = channel;
  }

  _createClass(APIClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._channel.invoke('app:getSchema');

              case 2:
                this._schemas = _context.sent;
                this._node = new node_1.Node(this._channel);
                this._account = new account_1.Account(this._channel, this._schemas);
                this._block = new block_1.Block(this._channel, this._schemas);
                _context.next = 8;
                return this._node.getNodeInfo();

              case 8:
                this._nodeInfo = _context.sent;
                this._transaction = new transaction_1.Transaction(this._channel, this._schemas, this._nodeInfo);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._channel.disconnect());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actionName, params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._channel.invoke(actionName, params));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function invoke(_x, _x2) {
        return _invoke.apply(this, arguments);
      }

      return invoke;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(eventName, cb) {
      this._channel.subscribe(eventName, cb);
    }
  }, {
    key: "schemas",
    get: function get() {
      return this._schemas;
    }
  }, {
    key: "node",
    get: function get() {
      return this._node;
    }
  }, {
    key: "account",
    get: function get() {
      return this._account;
    }
  }, {
    key: "block",
    get: function get() {
      return this._block;
    }
  }, {
    key: "transaction",
    get: function get() {
      return this._transaction;
    }
  }]);

  return APIClient;
}();

exports.APIClient = APIClient;